import styled from "styled-components";

export const AdjustStrategyContainer = styled.div`

`